import { appConfigApi } from "./api.service";

export const STORAGE_KEY = 'LENS_API_API';
export const COGNITO_CONFIG_KEY = 'LENS_COGNITO_CONFIG';

export const getLensApi = () => {
    const data = localStorage.getItem(STORAGE_KEY);
    return JSON.parse(data);
}

export const getCognitoConfig = async () => {
    const configData = await getAppConfig();

    // Find Cognito config values from the config array
    const domain = configData?.find((c: any) => c.configName === 'cognito.domain')?.configValue;
    const clientId = configData?.find((c: any) => c.configName === 'cognito.clientId')?.configValue;
    const responseType = configData?.find((c: any) => c.configName === 'cognito.responseType')?.configValue;
    const scope = configData?.find((c: any) => c.configName === 'cognito.scope')?.configValue;

    // Validate all required config values exist
    if (!domain || !clientId || !responseType || !scope) {
        throw new Error('Missing required Cognito configuration');
    }

    return { domain, clientId, responseType, scope };
}

export const getCognitoAdminGroups = async (): Promise<string[]> => {
    try {
        const configData = await getAppConfig();
        const adminGroupsValue = configData?.find((c: any) => c.configName === 'cognito.adminGroups')?.configValue;

        console.log('cognito.adminGroups raw value from config:', adminGroupsValue);

        if (adminGroupsValue) {
            // Split by comma and trim whitespace from each group name
            const adminGroups = adminGroupsValue.split(',').map((group: string) => group.trim());
            console.log('Parsed admin groups:', adminGroups);
            return adminGroups;
        } else {
            console.log('cognito.adminGroups not found in config');
        }
    } catch (error) {
        console.error('Error fetching Cognito admin groups from API:', error);
    }

    // Fallback to empty array - no admin groups configured
    return [];
}



export const getVoiceApi = () => getLensApi()?.voice;
export const getDigitalApi = () => getLensApi()?.digital;
export const getDashboardUrl = () => getLensApi()?.dashboard

export const baseLensApi = () => new URL(getVoiceApi()).origin;

export const getAppConfig = async () => {
    const { data } = await appConfigApi.get('');
    return data?.data;
}


export const updateAppConfig = async (formData: any) => {
    if (formData.id) {
        await appConfigApi.put('', { ...formData });
    } else {
        await appConfigApi.post('', { ...formData });
    }

    return true;
}



export const deleteAppConfig = async (ids: any[]) => {
    await Promise.all(
        ids.map(async (id:number) => {

            await appConfigApi.delete(`/${id}`);
            return true;
        })
    )
    return true;
}